import { IconProps } from "../../../types/style";

const RowsIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M16.69 2.5H8.31C4.67 2.5 2.5 4.67 2.5 8.31V16.68C2.5 20.33 4.67 22.5 8.31 22.5H16.68C20.32 22.5 22.49 20.33 22.49 16.69V8.31C22.5 4.67 20.33 2.5 16.69 2.5Z"
          fill={color}
        />
        <path
          d="M18.5 9H6.5C6.09 9 5.75 8.66 5.75 8.25C5.75 7.84 6.09 7.5 6.5 7.5H18.5C18.91 7.5 19.25 7.84 19.25 8.25C19.25 8.66 18.91 9 18.5 9Z"
          fill={color}
        />
        <path
          d="M16.5 13.25H8.5C8.09 13.25 7.75 12.91 7.75 12.5C7.75 12.09 8.09 11.75 8.5 11.75H16.5C16.91 11.75 17.25 12.09 17.25 12.5C17.25 12.91 16.91 13.25 16.5 13.25Z"
          fill={color}
        />
        <path
          d="M13.8302 17.5H11.1602C10.7502 17.5 10.4102 17.16 10.4102 16.75C10.4102 16.34 10.7502 16 11.1602 16H13.8302C14.2402 16 14.5802 16.34 14.5802 16.75C14.5802 17.16 14.2502 17.5 13.8302 17.5Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default RowsIcon;
